<template>
  <v-card>
    <v-card-title class="green lighten-4 font-weight-bold primary--text"
      >Anexar documentos</v-card-title
    >
    <v-card-subtitle class="green lighten-4">Plano de Saúde</v-card-subtitle>
    <v-card-text :class="classCardBody()">
      <v-card
        flat
        class="grey lighten-3 rounded-lg mt-2"
        v-for="(dep, i) in dependentes"
        :key="i"
      >
        <v-card-title class="font-weight-bold">{{ dep.nome }}</v-card-title>
        <v-card-subtitle class="warning--text pb-1"
          ><v-chip color="grey" dark x-small>{{
            dep.parentesco
          }}</v-chip></v-card-subtitle
        >
        <v-card-text>
          <v-list class="grey lighten-3 pt-0">
            <v-list-item
              class="grey lighten-5 rounded mt-1"
              v-for="cfg in docsSelecsAnexar(dep)"
              :key="cfg.cod_documento"
            >
              <v-list-item-content>
                <v-list-item-title>{{ cfg.desc_documento }}</v-list-item-title>
                <!-- Todos os documentos agora são opcionais -->
                <v-list-item-subtitle class="info--text"
                  >Opcional</v-list-item-subtitle
                >
              </v-list-item-content>
              <v-list-item-action>
                <input
                  type="file"
                  ref="file"
                  :id="idFile(cfg)"
                  v-show="false"
                  accept="image/jpeg,image/png,application/pdf"
                  @change="selecionarArquivo(cfg)"
                />

                <template v-if="isMobile()">
                  <v-btn
                    v-if="temAnexo(cfg)"
                    icon
                    color="error"
                    @click="removerDoc(cfg)"
                    ><v-icon>mdi-delete-outline</v-icon></v-btn
                  >
                  <v-btn v-else icon color="teal" @click="anexarDoc(cfg)" dark
                    ><v-icon size="30">mdi-upload</v-icon></v-btn
                  >
                </template>
                <template v-else>
                  <v-btn
                    v-if="temAnexo(cfg)"
                    rounded
                    small
                    color="error"
                    @click="removerDoc(cfg)"
                    ><v-icon size="18" class="mr-2">mdi-delete-outline</v-icon>
                    Remover</v-btn
                  >
                  <v-btn
                    small
                    rounded
                    color="teal"
                    dark
                    @click="anexarDoc(cfg)"
                    v-else
                  >
                    <v-icon size="18" class="mr-2">mdi-upload</v-icon>
                    Anexar</v-btn
                  >
                </template>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-card-text>
    <v-card-actions>
      <slot></slot>
    </v-card-actions>
  </v-card>
</template>

<script>
import { getBase64 } from "@/global";
import { mapState } from "vuex";
export default {
  computed: mapState("planoSaude", ["configDocs", "docsAnexados"]),
  props: {
    dependentes: Array,
    codConfig: Number,
  },
  methods: {
    docsSelecsAnexar(depend) {
      return this.configDocs.filter(
        (cfg) =>
          cfg.cod_config == this.codConfig &&
          cfg.cod_dependente == depend.codigo
      );
    },
    isMobile() {
      return this.$mq == "sm";
    },
    classCardBody() {
      return this.isMobile() ? "pt-2 pr-3 pl-3" : "pt-2";
    },
    anexarDoc(cfg) {
      this.$refs.file.find((ref) => ref.id == this.idFile(cfg)).click();
    },
    idFile(cfg) {
      return `${cfg.cod_documento}${cfg.cod_dependentes}`;
    },
    async selecionarArquivo(cfg) {
      var arq = this.$refs.file.find((ref) => ref.id == this.idFile(cfg))
        .files[0];
      var arq64 = await getBase64(arq);

      this.docsAnexados.push({
        cod_documento: cfg.cod_documento,
        cod_dependente: cfg.cod_dependente,
        arquivo: arq64.split(",")[1],
      });
    },
    temAnexo(cfg) {
      return (
        this.docsAnexados.findIndex(
          (docAnex) =>
            docAnex.cod_documento == cfg.cod_documento &&
            docAnex.cod_dependente == cfg.cod_dependente
        ) >= 0
      );
    },
    removerDoc(cfg) {
      var pos = this.docsAnexados.findIndex(
        (doc) =>
          doc.cod_documento == cfg.cod_documento &&
          doc.cod_dependente == cfg.cod_dependente
      );
      this.docsAnexados.splice(pos, 1);
    },
  },
};
</script>

<style></style>
